import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { AvailabilityParams, AvailabilityResponse } from "@/api/types";

function cleanParams(params: AvailabilityParams): Record<string, string> {
  const clean: Record<string, string> = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "") {
      clean[key] = String(value);
    }
  }
  return clean;
}

export function useAvailability(slug: string, params: AvailabilityParams) {
  return useQuery({
    queryKey: ["businesses", slug, "availability", params],
    queryFn: () =>
      api
        .get(`businesses/${slug}/availability`, { searchParams: cleanParams(params) })
        .json<AvailabilityResponse>(),
    enabled: !!slug && !!params.date && !!(params.service_id || params.booking_id),
    staleTime: 60_000,
    refetchOnMount: "always",
  });
}
